import * as Url from "./Utils/UrlUtil";
import * as Intro from "./Intros/_IntroBase";

import * as SettlementFilterIntro from './Intros/_settlementFilter';
import * as DxFilter from "./_devexpressFilter";
import * as DxFilterDate from "./_dateFilterPanel";

const FilingListBaseFilterSettingName: string = "FilingList-BaseFilter-Value";
const FilingListFilterSwitchSettingName: string = "FilingList-FilterSwitch-Value";

let isFirstLoad: Boolean = true;

function InitFilters() {
    DxFilter.InitFavoriteSettlementFilter(FilingListFilterSwitchSettingName);
}

function SetFilterVisibility(displayDateAndSettlementFilter: boolean) {
    DxFilterDate.SetDateFilterSectionVisibility(displayDateAndSettlementFilter);

    DxFilter.LoadFavoriteSettlementFilterValueFromSettings(displayDateAndSettlementFilter, FilingListFilterSwitchSettingName);
    DxFilter.SetFavoriteSettlementFilterVisibility(displayDateAndSettlementFilter);
}

export function OnInitFilingList(s: MVCxClientGridView, e: ASPxClientEventArgs) {
    let baseFilter: JQuery = $('#BaseFilter');
    let haveToStoreView: boolean = $('#BaseFilter').attr('data-have-to-store-view') === 'True';

    if (haveToStoreView) {
            let view: string = window.SettingsManager.getAttribute(FilingListBaseFilterSettingName);

        if (view) {
            baseFilter.val(view);
        }
    }

    InitFilters();

    let baseFilterValue: string = $('#BaseFilter option:selected').val() as string;
    let displayDateAndSettlementFilter: boolean = ShouldDisplayDateAndSettlementFilter(baseFilterValue);

    SetFilterVisibility(displayDateAndSettlementFilter);

    s.Refresh();

    if (displayDateAndSettlementFilter) {
        Intro.AutoRunIntro(() => SettlementFilterIntro.settlementFilterAutoStart(), 'settlementFilterIntro');
    }
}

export function FilingListBeginCallback(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    DxFilterDate.CheckAndCorrectDateFilterValues();

    let baseFilter: string = $('#BaseFilter').val() as string;
    let filterForFavoriteSettlements: string = $('#settlement-filter').is(':visible') && $('.f-f-f-s').prop('checked');

    e.customArgs['baseFilterId'] = baseFilter;
    e.customArgs['filterForFavoriteSettlements'] = filterForFavoriteSettlements;
    e.customArgs['isFirstLoad'] = isFirstLoad;

    let needToFilterByDate: boolean = $('#date-filter-area').is(':visible');

    if (needToFilterByDate) {
        let fromDate: string = $('.dfflt-from').val() as string;
        let toDate: string = $('.dfflt-to').val() as string;

        e.customArgs['fromDate'] = fromDate;
        e.customArgs['toDate'] = toDate;
    }

    isFirstLoad = false;
}

export function FilingListEndCallback(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    DxFilter.ToggleAlertVisibilityForProcessAndFilingList(s);
}

export function OnSelectionChangedInFilingList(s: MVCxClientGridView, e: ASPxClientGridViewFocusEventArgs) {
    let rowIndex: number = s.GetFocusedRowIndex();

    if (rowIndex >= 0) {
        let processActionId: string = s.GetRowKey(rowIndex);
        $("#DetailsButton").attr("href", generateProcessActionEditUrlForOffice(processActionId));
    }
}

export function OnFilingListGridFocusedRowChanged(s: MVCxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    let $chooseBtn: JQuery = $('#chooseButton');
    let rowIndex: number = s.GetFocusedRowIndex();
    let selectedProcessActionId: string = s.GetRowKey(rowIndex);
    let urlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.ProcessActionEdit'];
    let url: string = Url.createUrlFromTemplate(urlTemplate, { processActionId: selectedProcessActionId });

    $chooseBtn.attr('href', url);
}

export function OnRowClickFiling(s: MVCxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    let htmlEvent = e.htmlEvent as Event;
    let target = htmlEvent.target as Element;

    if (target.classList.contains('dxgvCommandColumn')) {
        return;
    }

    let processActionId: string = s.GetRowKey(e.visibleIndex);

    if (processActionId !== null) {
        window.open(generateProcessActionEditUrlForOffice(processActionId), '_blank');
    }
}

function generateProcessActionEditUrlForOffice(processActionId: string) {
    return Url.createUrlFromTemplate(window.ETDR_RD.appConfig["UrlTemplate.ProcessActionEdit"], { processActionId: processActionId });
}

export function OnBaseFilterChangedOnFilingList() {

    let baseFilter: JQuery = $('#BaseFilter');
    let baseFilterValue: string = $('#BaseFilter option:selected').val() as string;
    let haveToStoreView: boolean = baseFilter.attr('data-have-to-store-view') === 'True';
    let displayDateAndSettlementFilter: boolean = ShouldDisplayDateAndSettlementFilter(baseFilterValue);

    SetFilterVisibility(displayDateAndSettlementFilter);

    if (haveToStoreView) {
        window.SettingsManager.setAttribute(FilingListBaseFilterSettingName, baseFilter.val());
    }

    let grid: MVCxClientGridView = window['FilingList'] as MVCxClientGridView;
    grid.PerformCallback({ 'viewChanged': true });

    if (displayDateAndSettlementFilter) {
        Intro.AutoRunIntro(() => SettlementFilterIntro.settlementFilterAutoStart(), 'settlementFilterIntro');
    }
}

function ShouldDisplayDateAndSettlementFilter(baseFilterValue: string): boolean {
    return baseFilterValue !== "Megosztott";
}

jQuery(() => {
    $('.fl-bf-element').change(() => OnBaseFilterChangedOnFilingList());
});
